import { FC, useState } from "react";
import Form from "react-bootstrap/Form";
import styles from "./style.module.scss";
import { IoEyeOffSharp, IoEyeSharp } from "react-icons/io5";

interface StateProps {
  name: string;
  id: string;
  onChange?: (data: any) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  type?: string;
  placeholder?: string;
  width?: string;
  height?: string;
  className?: string;
  value?: string | number;
  required?: boolean;
  errrorMessage?: string;
  readonly?: boolean;
  autoComplete?: string;
  isInvalid?: any;
  min?: any;
}

const TextInput: FC<StateProps> = ({
  className = styles.inputText,
  name,
  id,
  placeholder,
  width,
  height,
  onChange,
  onBlur,
  value,
  type = "text",
  required,
  errrorMessage,
  readonly = false,
  isInvalid,
  autoComplete = "off",
  min = "",
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";
  const inputType = isPassword ? (showPassword ? "text" : "password") : type;

  return (
    <div style={{ position: "relative", width }}>
      <Form.Control
        type={inputType}
        name={name}
        id={id}
        placeholder={placeholder}
        style={{ height }}
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        className={className}
        required={required}
        readOnly={readonly}
        isInvalid={isInvalid}
        autoComplete={autoComplete}
        min={min}
        data-testid={`input-${id}`}
      />
      {isPassword && (
        <span
          onClick={() => setShowPassword(!showPassword)}
          className={`${styles.eyeinput} ${errrorMessage ? styles.eyeinputError : ""}`}
          data-testid="password-toggle"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setShowPassword(!showPassword);
            }
          }}
        >
          {showPassword ? <IoEyeOffSharp /> : <IoEyeSharp />}
        </span>
      )}
      <Form.Control.Feedback type="invalid">
        {errrorMessage}
      </Form.Control.Feedback>
    </div>
  );
};

export default TextInput;
